function getLinkAttributesFromDestinationType(destinationType, isEnglish) {
  switch (destinationType) {
    case 'indicator':
      return {
        destinationIcon: 'angle-right',
        target: null,
        rel: null,
        destinationA11yLabel: null
      };

    case 'external':
      return {
        destinationIcon: 'external-link',
        target: '_blank',
        rel: 'noreferrer noopener',
        destinationA11yLabel: isEnglish ? 'Opens external website in a new window' : 'Un site externe s’affiche dans une nouvelle fenêtre'
      };

    case 'internal-new-tab':
      return {
        destinationIcon: 'popup',
        target: '_blank',
        rel: 'noreferrer noopener',
        destinationA11yLabel: isEnglish ? 'Opens in a new window' : 'Une nouvelle fenêtre s’affiche'
      };

    case undefined:
    case null:
      return {
        destinationIcon: null,
        target: null,
        rel: null,
        destinationA11yLabel: null
      };

    default:
      console.warn(`Invalid Input: ${destinationType} is not a valid destination type.`);
      return {
        destinationIcon: null,
        target: null,
        rel: null,
        destinationA11yLabel: null
      };
  }
}

var CTATextIconSizeMap;

(function (CTATextIconSizeMap) {
  CTATextIconSizeMap[CTATextIconSizeMap["default"] = 24] = "default";
  CTATextIconSizeMap[CTATextIconSizeMap["compact"] = 20] = "compact";
  CTATextIconSizeMap[CTATextIconSizeMap["comfortable"] = 28] = "comfortable";
})(CTATextIconSizeMap || (CTATextIconSizeMap = {}));

function commonInterfaces() {
  return 'common-interfaces';
}
function getPath(o, propertyName) {
  return o[propertyName];
}
/**
 * Type guard for checking if a value is neither null nor undefined
 */

const doesExist = thing => {
  if (thing !== null && thing !== undefined) return true;
  return false;
};

var NavigationPanelPosition;

(function (NavigationPanelPosition) {
  NavigationPanelPosition["left"] = "left";
  NavigationPanelPosition["right"] = "right";
  NavigationPanelPosition["inPage"] = "in-page";
})(NavigationPanelPosition || (NavigationPanelPosition = {}));

var PanelPosition;

(function (PanelPosition) {
  PanelPosition["center"] = "center";
  PanelPosition["left"] = "left";
  PanelPosition["right"] = "right";
  PanelPosition["top"] = "top";
  PanelPosition["bottom"] = "bottom";
  PanelPosition["inlineOccluding"] = "inline-occluding";
  PanelPosition["inlineAdjacent"] = "inline-adjacent";
})(PanelPosition || (PanelPosition = {}));

function isPanelInitiatorString(thing) {
  return typeof thing === 'string';
}
function isPanelInitiatorElement(thing) {
  return thing?.nodeName !== undefined;
}

function isPaddingSpacing(thing) {
  return thing != null && (thing.paddingHorizontal !== undefined || thing.paddingVertical !== undefined);
}
function isMarginSpacing(thing) {
  return thing != null && (thing.marginHorizontal !== undefined || thing.marginVertical !== undefined);
}

const ContentEN = {
  back: 'Back',
  close: 'Close',
  clear: 'Clear',
  danger: 'Attention',
  info: 'Information alert:',
  success: 'Done',
  warning: 'Warning'
};
const ContentFR = {
  back: 'Précédent',
  close: 'Fermer',
  clear: 'Effacer',
  danger: 'Attention',
  info: "Alerte d'information :",
  success: "C'est fait!",
  warning: 'Avertissement'
};
function getContent(locale) {
  return locale.includes('en') ? ContentEN : ContentFR;
}

// TO-DO: Strengthen interface to centralize all error-handling (maybe needs to be renamed to be a general logger)
function throwError(outputString) {
  throw new Error(outputString); // what format should we follow for our errors?
}
function logWarning(outputString) {
  console.warn(outputString); // what format should we follow for our warnings?
}

const SelectInputIconSizeMap = new Map([['default', 20], ['compact', 16], ['comfortable', 24]]);
const SelectTrailingIconSizeMap = new Map([['default', 16], ['compact', 12], ['comfortable', 16]]);

function isRangeInput(thing) {
  if (thing) {
    const that = thing;
    return that.min !== undefined && that.max !== undefined && that.step !== undefined && that.step > 0 && that.label !== undefined;
  }

  return false;
}
function isPreciseContinuousSlider(thing) {
  return thing != null && thing.kind === 'precise';
}
function isDefaultContinuousSlider(thing) {
  return thing != null && thing.kind === 'default';
}
function isOrdinalSlider(thing) {
  if (thing) {
    const that = thing;
    return that.options !== undefined && that.options.length > 1;
  }

  return false;
}

const KEYVALUEITEMDEFAULTS = {
  KEYVALUESPACING: '5xs',
  VALUESPACING: '5xs',
  KEYVERTICALALIGNMENT: 'top',
  VALUEVERTICALALIGNMENT: 'top',
  ITEMPADDING: 'z'
};

var KIND;

(function (KIND) {
  KIND["STACKED"] = "stacked";
  KIND["ENDTOEND"] = "endtoend";
  KIND["SIDEBYSIDE"] = "sidebyside";
})(KIND || (KIND = {}));

const KEYVALUELISTDEFAULTS = {
  KIND: 'stacked',
  DENSITY: 'default',
  EMPHASIS: 'value',
  REDUCEKEYSIZE: true,
  KEYHORIZONTALSIZE: 50,
  ITEMSPACING: '2xs',
  LISTPADDING: 'z'
};

var ListKinds;

(function (ListKinds) {
  ListKinds["symbol"] = "symbol";
  ListKinds["ordered"] = "ordered";
  ListKinds["unstyled"] = "unstyled";
  ListKinds["icon"] = "icon";
})(ListKinds || (ListKinds = {}));

const FontFormatExtension = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'embedded-opentype': 'eot',
  svg: 'svg',
  woff: 'woff'
};
var ImageSize;

(function (ImageSize) {
  ImageSize["sm"] = "sm";
  ImageSize["md"] = "md";
  ImageSize["lg"] = "lg";
})(ImageSize || (ImageSize = {}));

const FontWeights = {
  light: 300,
  regular: 400,
  medium: 500,
  bold: 600,
  extrabold: 700
};
const SupportedFontStyles = ['italic'];

const AvatarSizeMap = {
  xs: 16,
  sm: 24,
  md: 32,
  lg: 64
};
const AvatarIconScale = 0.5;

var Breakpoint;

(function (Breakpoint) {
  Breakpoint["extraSmall"] = "xs";
  Breakpoint["small"] = "sm";
  Breakpoint["medium"] = "md";
  Breakpoint["large"] = "lg";
  Breakpoint["extraLarge"] = "xl";
  Breakpoint["extraExtraLarge"] = "2xl";
})(Breakpoint || (Breakpoint = {}));

function isBreakpointRange(thing) {
  return thing != null && thing.min !== undefined && typeof thing.min === 'number';
}
const Breakpoints = {
  xs: {
    min: 0,
    max: 575
  },
  sm: {
    min: 576,
    max: 767
  },
  md: {
    min: 768,
    max: 991
  },
  lg: {
    min: 992,
    max: 1183
  },
  xl: {
    min: 1184,
    max: 1347
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '2xl': {
    min: 1348
  }
};
function getBreakpoint(screenWidth) {
  if (isExtraSmallBreakpoint(screenWidth)) {
    return Breakpoint.extraSmall;
  } else if (isSmallBreakpoint(screenWidth)) {
    return Breakpoint.small;
  } else if (isMediumBreakpoint(screenWidth)) {
    return Breakpoint.medium;
  } else if (isLargeBreakpoint(screenWidth)) {
    return Breakpoint.large;
  } else if (isExtraLargeBreakpoint(screenWidth)) {
    return Breakpoint.extraLarge;
  } else {
    return Breakpoint.extraExtraLarge;
  }
}
function getBreakpointRange(value) {
  if (isBreakpointRange(value)) {
    return value;
  }

  return Breakpoints[value];
}
function isBreakpointContained(width, value) {
  const range = getBreakpointRange(value);
  const result = width >= range.min;

  if (range.max !== undefined) {
    return result && width <= range.max;
  }

  return result;
}
function isBreakpointAtMost(width, value) {
  const range = getBreakpointRange(value);

  if (range.max !== undefined) {
    return width < range.max;
  }

  return true;
}
function isBreakpointAtLeast(width, value) {
  const range = getBreakpointRange(value);
  return width >= range.min;
}
function isExtraSmallBreakpoint(screenWidth) {
  return isBreakpointContained(screenWidth, Breakpoints.xs);
}
function isSmallBreakpoint(screenWidth) {
  return isBreakpointContained(screenWidth, Breakpoints.sm);
}
function isMediumBreakpoint(screenWidth) {
  return isBreakpointContained(screenWidth, Breakpoints.md);
}
function isLargeBreakpoint(screenWidth) {
  return isBreakpointContained(screenWidth, Breakpoints.lg);
}
function isExtraLargeBreakpoint(screenWidth) {
  return isBreakpointContained(screenWidth, Breakpoints.xl);
}
function isExtraExtraLargeBreakpoint(screenWidth) {
  return isBreakpointContained(screenWidth, Breakpoints['2xl']);
}

function isIconAllyEnabled(thing) {
  return thing?.decorative === false;
}
function isIconA11yDisabled(thing) {
  return !!thing && (thing.decorative === true || thing.decorative === undefined);
}
function normalizeIconSize(size) {
  switch (size) {
    case 'sm':
    case 's':
    case 'md':
      return 's';

    case 'm':
    case 'lg':
      return 'm';

    case 'l':
    case 'xl':
      return 'l';

    default:
      if (typeof size === 'number') {
        if (size <= 31) {
          return 's';
        } else if (size <= 48) {
          return 'm';
        } else {
          return 'l';
        }
      }

      return 's';
  }
}

function isStaticRegistryItem(thing) {
  return !!thing && thing.url !== undefined;
}
function isManifestRegistryItem(thing) {
  return !!thing && thing.manifest !== undefined;
}
function isSvgElement(thing) {
  return thing != null && thing.nodeName?.toLowerCase() === 'svg';
}
function canBustManifestCache(thing) {
  return !!thing && thing.manifestBust === true;
}
function getMediaCacheId(token, size) {
  return [token.scope || 'default', token.name, mapIconSizeToSuffix(size)].join('-');
}
function getIconSpriteId(token, size, sizeDefault) {
  return [token.scope || 'default', mapIconSizeToSuffix(size, sizeDefault)].join('-');
}
function mapIconSizeToSuffix(size, emptyDefault) {
  const val = normalizeIconSize(size ?? 's');

  if (val === emptyDefault) {
    return undefined;
  }

  return val;
}

var LoaderKind;

(function (LoaderKind) {
  LoaderKind["inline"] = "inline";
  LoaderKind["full"] = "full";
  LoaderKind["inSegment"] = "in-segment";
})(LoaderKind || (LoaderKind = {}));

var LoaderTextPosition;

(function (LoaderTextPosition) {
  LoaderTextPosition["center"] = "center";
  LoaderTextPosition["bottom"] = "bottom";
})(LoaderTextPosition || (LoaderTextPosition = {}));

function isMediaManifestRecord(thing) {
  return isMediaManifestRecordWithPath(thing) || isMediaManifestRecordWithSizes(thing);
}
function isMediaManifest(thing) {
  return !!thing && thing.assets !== undefined;
}
function assertMediaManifest(thing) {
  if (!isMediaManifest(thing)) {
    throw new Error('object is not a MediaManifest');
  }
}
function isMediaManifestRecordWithSizes(thing) {
  return thing?.sizes !== undefined;
}
function isMediaManifestRecordWithPath(thing) {
  return thing?.path !== undefined;
}
function isMinifiedMediaManifest(thing) {
  const manifest = thing;
  return !!manifest && manifest.assets && Object.values(manifest?.assets)?.length > 0 && Object.values(manifest?.assets).every(value => typeof value === 'string' || isPartialManifestMediaDataSizes(value));
}
function isPartialManifestMediaDataSizes(thing) {
  return typeof thing?.sm === 'string' || typeof thing?.md === 'string' || typeof thing?.lg === 'string';
}
function isManifestMediaDataSizes(thing) {
  return !!thing && typeof thing.sm === 'string' && typeof thing.md === 'string' && typeof thing.lg === 'string';
}
function convertMinifiedMediaManifest(minifiedManifest) {
  const manifest = {};
  let spriteLg, spriteMd, spriteSm;

  if (minifiedManifest.sprites) {
    const {
      lg,
      md,
      sm
    } = minifiedManifest.sprites;
    spriteLg = lg;
    spriteMd = md;
    spriteSm = sm;
  }

  Object.keys(minifiedManifest.assets).forEach(key => {
    const asset = minifiedManifest.assets[key];

    if (typeof asset === 'string') {
      manifest[key] = {
        path: asset
      };
    } else {
      const {
        lg: assetLg,
        md: assetMd,
        sm: assetSm,
        label
      } = asset;
      const sizes = {};

      if (assetLg) {
        sizes.lg = {
          asset: assetLg,
          sprite: spriteLg,
          label
        };
      }

      if (assetMd) {
        sizes.md = {
          asset: assetMd,
          sprite: spriteMd,
          label
        };
      }

      if (assetSm) {
        sizes.sm = {
          asset: assetSm,
          sprite: spriteSm,
          label
        };
      }

      manifest[key] = {
        sizes
      };
    }
  });
  return manifest;
}
function validateManifestData(manifest) {
  if (isMinifiedMediaManifest(manifest)) {
    return true;
  } else {
    console.warn('Failed to access manifest from config because the format is invalid');
    return false;
  }
}

/** @deprecate since 3.0.0, replaced with getMediaToken */
function getIconToken(name) {
  return getMediaToken(name);
}
function getMediaToken(name) {
  const parts = name.split(':');

  if (parts.length === 2) {
    return {
      scope: parts[0],
      name: parts[1]
    };
  } else {
    return {
      name
    };
  }
}

let iconUniqueID = 0;
class SvgUtils {
  static cloneSvg(svg) {
    return svg?.cloneNode(true);
  }

  static setSvgElement(svg, element, role) {
    SvgUtils.clearSvgElement(element); // Workaround for IE11 and Edge ignoring `style` tags inside dynamically-created SVGs.
    // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10898469/
    // Do this before inserting the element into the DOM, in order to avoid a style recalculation.

    svg = SvgUtils.clearStyleTags(svg);
    svg.setAttribute('role', role);
    element.appendChild(svg);
    return svg;
  }

  static addA11ytoSVG(svg, name, label, document, description) {
    if (svg && label) {
      const title = document.createElement('title');
      const titleUniqueId = `-title-${++iconUniqueID}`;
      const descUniqueId = `-desc-${iconUniqueID}`;
      title.setAttribute('id', name + titleUniqueId);
      title.innerHTML = label;
      svg.appendChild(title);
      const labelIds = [name + titleUniqueId];

      if (description) {
        const desc = document.createElement('desc');
        desc.setAttribute('id', name + descUniqueId);
        desc.innerHTML = description;
        svg.appendChild(desc);
        labelIds.push(name + descUniqueId);
      }

      svg.setAttribute('aria-labelledby', labelIds.join(' '));
    }

    return svg;
  }

  static clearSvgElement(element) {
    const layoutElement = element;
    let childCount = layoutElement.childNodes.length; // Remove existing non-element child nodes and SVGs, and add the new SVG element. Note that
    // we can't use innerHTML, because IE will throw if the element has a data binding.

    while (childCount--) {
      const child = layoutElement.childNodes[childCount]; // 1 corresponds to Node.ELEMENT_NODE. We remove all non-element nodes in order to get rid
      // of any loose text nodes, as well as any SVG elements in order to remove any old icons.

      if (child.nodeType !== 1 || child.nodeName.toLowerCase() === 'svg') {
        layoutElement.removeChild(child);
      }
    }
  }

  static createEmptySvg(document) {
    const div = document.createElement('DIV');
    return SvgUtils.svgElementFromString('<svg></svg>', div);
  }

  static setSvgAttributes(svg) {
    svg.setAttribute('fit', '');
    svg.setAttribute('height', '100%');
    svg.setAttribute('width', '100%');
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    svg.setAttribute('focusable', 'false'); // Disable IE11 default behavior to make SVGs focusable.

    return svg;
  }

  static getIconNameNotFound(iconName) {
    return Error(`Unable to find icon with the name '${iconName}'`);
  }

  static getFailedToSanitizeUrlError(url) {
    return Error(`The URL provided to RBC Icon was not trusted as a resource URL ` + `Attempted URL was '${url}'.`);
  }

  static iconKey(name, size) {
    return `${name}:${SvgUtils.getMapPath(size)}`;
  }

  static getMapPath(size) {
    switch (size) {
      case 'sm':
      case 's':
      case 'md':
        return 'sm';

      case 'm':
      case 'lg':
        return 'md';

      case 'l':
      case 'xl':
        return 'lg';

      default:
        if (typeof size === 'number') {
          if (size <= 31) {
            return 'sm';
          } else if (size <= 48) {
            return 'md';
          } else {
            return 'lg';
          }
        }

        return 'sm';
    }
  }

  static svgElementFromString(str, div) {
    div.innerHTML = str;
    const svg = div.querySelector('svg');

    if (!svg) {
      throw Error('<svg> tag not found');
    }

    return svg;
  }

  static getPath(size) {
    switch (SvgUtils.getMapPath(size)) {
      case 'sm':
        return '';

      case 'md':
        return '-md';

      case 'lg':
        return '-lg';

      default:
        return '';
    }
  }

  static clearStyleTags(svg) {
    const styleTags = svg.querySelectorAll('style');

    for (let i = 0; i < styleTags.length; i++) {
      styleTags[i].textContent += ' ';
    }

    return svg;
  }

  static extractSvgIconFromSet(iconSet, iconName, document) {
    // Use the `id="iconName"` syntax in order to escape special
    // characters in the ID (versus using the #iconName syntax).
    const iconSource = iconSet.querySelector(`[id="${iconName}"]`);

    if (!iconSource) {
      throw SvgUtils.getIconNameNotFound(iconName);
    } // Clone the element and remove the ID to prevent multiple elements from being added
    // to the page with the same ID.


    const iconElement = iconSource.cloneNode(true);
    iconElement.removeAttribute('id'); // If the icon node is itself an <svg> node, clone and return it directly. If not, set it as
    // the content of a new <svg> node.

    if (iconElement.nodeName.toLowerCase() === 'svg') {
      return SvgUtils.setSvgAttributes(iconElement);
    } // If the node is a <symbol>, it won't be rendered so we have to convert it into <svg>. Note
    // that the same could be achieved by referring to it via <use href="#id">, however the <use>
    // tag is problematic on Firefox, because it needs to include the current page path.


    if (iconElement.nodeName.toLowerCase() === 'symbol') {
      return SvgUtils.setSvgAttributes(SvgUtils.toSvgElement(iconElement, document));
    } // createElement('SVG') doesn't work as expected; the DOM ends up with
    // the correct nodes, but the SVG content doesn't render. Instead we
    // have to create an empty SVG node using innerHTML and append its content.
    // Elements created using DOMParser.parseFromString have the same problem.
    // http://stackoverflow.com/questions/23003278/svg-innerhtml-in-firefox-can-not-display


    const svg = SvgUtils.createEmptySvg(document); // Clone the node so we don't remove it from the parent icon set element.

    svg.appendChild(iconElement);
    return SvgUtils.setSvgAttributes(svg);
  }

  static toSvgElement(element, document) {
    const svg = SvgUtils.createEmptySvg(document); // Copy the viewbox to maintain sizing

    const viewBox = element.getAttribute('viewBox');

    if (viewBox) {
      svg.setAttribute('viewBox', viewBox);
    }

    for (let i = 0; i < element.childNodes.length; i++) {
      if (element.childNodes[i].nodeType === document.ELEMENT_NODE) {
        svg.appendChild(element.childNodes[i].cloneNode(true));
      }
    }

    return svg;
  }

}

function isNavigationUser(thing) {
  return thing != null && thing.fullName !== undefined;
}

function isSectionNavGroup(thing) {
  return thing != null && thing.children !== undefined;
}
function isSectionNavItem(thing) {
  if (thing) {
    const obj = thing;
    return thing != null && obj.target !== undefined && obj.text !== undefined;
  }

  return false;
}

var ProgressMode;

(function (ProgressMode) {
  ProgressMode["determinate"] = "determinate";
  ProgressMode["indeterminate"] = "indeterminate";
  ProgressMode["complete"] = "complete";
})(ProgressMode || (ProgressMode = {}));

const spacingTokens = new Map([['z', '0px'], ['5xs', '2px'], ['4xs', '4px'], ['3xs', '8px'], ['2xs', '12px'], ['xs', '16px'], ['s', '20px'], ['b', '24px'], ['m', '32px'], ['l', '40px'], ['xl', '48px'], ['2xl', '56px'], ['3xl', '64px'], ['4xl', '96px'], ['5xl', '128px']]);

function getTabIconDensity(density, innerWidth) {
  switch (density) {
    case 'compact':
      {
        return 20;
      }

    case 'comfortable':
      {
        return innerWidth === undefined || innerWidth >= Breakpoints.lg.min ? 28 : 24;
      }

    default:
      {
        return 24;
      }
  }
}

function getTabsToggleIconDensity(density) {
  return density === 'comfortable' ? 24 : 20;
}

// ENUMS
////////////////////////////////////////////////////////

var TextClass;

(function (TextClass) {
  TextClass["root"] = "rbc-text-";
  TextClass["breakpointPrefix"] = "--bp-";
  TextClass["lowEmphasis"] = "_low-emphasis";
})(TextClass || (TextClass = {}));

const TextKind = {
  heading: 'heading',
  ui: 'ui',
  paragraph: 'paragraph',
  bigNumber: 'bignumber'
};
const TextSize = {
  xxs: '2xs',
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  default: 'default',
  lg: 'lg',
  xl: 'xl',
  xxl: '2xl'
};
const TextEmphasis = {
  default: 'default',
  low: 'low'
}; ////////////////////////////////////////////////////////
// CONSTANTS
////////////////////////////////////////////////////////

const TextKindOptions = ['heading', 'ui', 'paragraph', 'bignumber'];
const TextSizeOptions = [TextSize.xxs, TextSize.xs, TextSize.sm, TextSize.md, TextSize.default, TextSize.lg, TextSize.xl, TextSize.xxl];
const TextEmphasisOptions = [TextEmphasis.default, TextEmphasis.low];
const TextBreakpointOptions = [Breakpoint.extraSmall, Breakpoint.small, Breakpoint.medium, Breakpoint.large, Breakpoint.extraLarge, Breakpoint.extraExtraLarge];
const TextTokenRules = {
  [TextKind.ui]: {
    sizes: [TextSize.xxs, TextSize.xs, TextSize.sm, TextSize.default, TextSize.lg, TextSize.xl],
    lowEmphasis: true
  },
  [TextKind.heading]: {
    sizes: [TextSize.xxs, TextSize.xs, TextSize.sm, TextSize.md, TextSize.lg, TextSize.xl, TextSize.xxl],
    lowEmphasis: false
  },
  [TextKind.paragraph]: {
    sizes: [TextSize.xs, TextSize.sm, TextSize.default, TextSize.lg, TextSize.xl, TextSize.xxl],
    lowEmphasis: false
  },
  [TextKind.bigNumber]: {
    sizes: [TextSize.xs, TextSize.sm, TextSize.default, TextSize.lg, TextSize.xl],
    lowEmphasis: true
  }
};
/**
 * Text strings used for error handling.
 */

const notSupportedByDirectiveMsg = `' not supported by rbcTextStyle directive.`;
const notSupportedByKindMsg = `' not supported by text kind '`; ////////////////////////////////////////////////////////
// METHODS
////////////////////////////////////////////////////////

/**
 * Verify input data is supported by directive.
 * @param inputData - user provided data
 */

function isTextInputDataValid(inputData) {
  if (inputData.kind && TextKindOptions.includes(inputData.kind)) {
    if (inputData.size && !TextTokenRules[inputData.kind].sizes.includes(inputData.size)) {
      throwError(`Size input value '${inputData.size}' for kind '${inputData.kind}${notSupportedByDirectiveMsg}`);
      return false;
    }

    if (inputData.emphasis && !TextEmphasisOptions.includes(inputData.emphasis)) {
      throwError('Emphasis input value `' + inputData.emphasis + notSupportedByDirectiveMsg);
      return false;
    }

    if (inputData.overrides) {
      const breakpoint = Object.keys(inputData.overrides)[0];
      const size = Object.values(inputData.overrides)[0];

      if (!TextTokenRules[inputData.kind].sizes.includes(size)) {
        throwError(`Override size input value '${size}' for kind '${inputData.kind}${notSupportedByDirectiveMsg}`);
        return false;
      } else if (!TextBreakpointOptions.includes(breakpoint)) {
        throwError(`Override breakpoint input value '${breakpoint}' for kind '${inputData.kind}${notSupportedByDirectiveMsg}`);
        return false;
      }
    }
  } else {
    throwError('Kind input value `' + inputData.kind + notSupportedByDirectiveMsg);
    return false;
  }

  return true;
}
/**
 * Create a class name for root text style, and all overrides (if provided).
 * @param inputData - user provided data for kind, size, and emphasis
 */

function createUtilityClassWithSize({
  kind,
  size
}) {
  let sizeText = '';

  if (kind === 'heading' && (size === 'default' || !size)) {
    sizeText = `-md`;
  } else if (size) {
    sizeText = `-${size}`;
  }

  return `${TextClass.root}${kind}${sizeText}`;
}
/**
 * Create all utility classes for root text style, and all overrides (if provided).
 * @param inputData - user provided data for kind, size, emphasis and overrides
 */

function createTextClassNames({
  kind,
  size,
  emphasis,
  overrides
}) {
  const tokenEmphasis = emphasis && emphasis === 'low' ? `${TextClass.root}${kind}${TextClass.lowEmphasis} ` : ``;
  let classNames = `${TextClass.root}${kind} ${tokenEmphasis}` + createUtilityClassWithSize({
    kind,
    size
  });

  if (overrides && Object.keys(overrides).length !== 0) {
    const overrideClasses = Object.entries(overrides).map(([breakpoint, overrideSize]) => {
      const bpSize = overrideSize;
      return `${createUtilityClassWithSize({
        kind,
        size: bpSize
      })}${TextClass.breakpointPrefix}${breakpoint}`;
    });
    classNames = classNames.split(' ').concat(overrideClasses).join(' ');
  }

  return classNames;
}

const BigNumberUseCase = {
  default: 'Default'
};
const BigNumberTextSizeMap = {
  [BigNumberUseCase.default]: TextSize.default
};

var HeadingLevel;

(function (HeadingLevel) {
  HeadingLevel["h1"] = "h1";
  HeadingLevel["h2"] = "h2";
  HeadingLevel["h3"] = "h3";
  HeadingLevel["h4"] = "h4";
  HeadingLevel["h5"] = "h5";
  HeadingLevel["h6"] = "h6";
})(HeadingLevel || (HeadingLevel = {}));
/** @deprecated since 3.0.0, style is now handled by useCase */


var HeadingStyle;

(function (HeadingStyle) {
  HeadingStyle["bigTitle1"] = "title-1";
  HeadingStyle["bigTitle2"] = "title-2";
  HeadingStyle["title1"] = "title-1";
  HeadingStyle["title2"] = "title-2";
  HeadingStyle["title3"] = "title-3";
  HeadingStyle["title4"] = "title-4";
  HeadingStyle["title5"] = "title-5";
  HeadingStyle["title6"] = "title-6";
})(HeadingStyle || (HeadingStyle = {}));

const HeadingUseCase = {
  noticeHeading: 'Notice Heading'
};
const HeadingTextSizeMap = {
  [HeadingUseCase.noticeHeading]: {
    size: TextSize.xxs,
    override: {
      [Breakpoint.large]: TextSize.xs
    }
  }
};

const ParagraphUseCase = {
  default: 'Default',
  introParagraph: 'Intro Paragraph',
  legalFootnote: 'Legal Footnote',
  imageCaption: 'Image Caption',
  transactionMemo: 'Transaction Memo',
  supportingDescription: 'Supporting Description'
};
const ParagraphTextSizeMap = {
  [ParagraphUseCase.default]: TextSize.default,
  [ParagraphUseCase.introParagraph]: TextSize.xxl,
  [ParagraphUseCase.legalFootnote]: TextSize.xs,
  [ParagraphUseCase.imageCaption]: TextSize.sm,
  [ParagraphUseCase.transactionMemo]: TextSize.sm,
  [ParagraphUseCase.supportingDescription]: TextSize.sm
};

const TextUIUseCase = {
  default: 'Default',
  formError: 'Form Error',
  formValue: 'Form Value',
  formInput: 'Form Input',
  cueText: 'Cue Text'
};
const TextUISizeMap = {
  [TextUIUseCase.default]: {
    size: TextSize.default,
    emphasis: TextEmphasis.default
  },
  [TextUIUseCase.formError]: {
    size: TextSize.default,
    emphasis: TextEmphasis.default
  },
  [TextUIUseCase.formValue]: {
    size: TextSize.default,
    emphasis: TextEmphasis.low
  },
  [TextUIUseCase.formInput]: {
    size: TextSize.default,
    emphasis: TextEmphasis.low
  },
  [TextUIUseCase.cueText]: {
    size: TextSize.sm,
    emphasis: TextEmphasis.low
  }
};

export { AvatarIconScale, AvatarSizeMap, BigNumberTextSizeMap, BigNumberUseCase, Breakpoint, Breakpoints, CTATextIconSizeMap, ContentEN, ContentFR, FontFormatExtension, FontWeights, HeadingLevel, HeadingStyle, HeadingTextSizeMap, HeadingUseCase, ImageSize, KEYVALUEITEMDEFAULTS, KEYVALUELISTDEFAULTS, KIND, ListKinds, LoaderKind, LoaderTextPosition, NavigationPanelPosition, PanelPosition, ParagraphTextSizeMap, ParagraphUseCase, ProgressMode, SelectInputIconSizeMap, SelectTrailingIconSizeMap, SupportedFontStyles, SvgUtils, TextBreakpointOptions, TextClass, TextEmphasis, TextEmphasisOptions, TextKind, TextKindOptions, TextSize, TextSizeOptions, TextTokenRules, TextUISizeMap, TextUIUseCase, assertMediaManifest, canBustManifestCache, commonInterfaces, convertMinifiedMediaManifest, createTextClassNames, createUtilityClassWithSize, doesExist, getBreakpoint, getBreakpointRange, getContent, getIconSpriteId, getIconToken, getLinkAttributesFromDestinationType, getMediaCacheId, getMediaToken, getPath, getTabIconDensity, getTabsToggleIconDensity, isBreakpointAtLeast, isBreakpointAtMost, isBreakpointContained, isBreakpointRange, isDefaultContinuousSlider, isExtraExtraLargeBreakpoint, isExtraLargeBreakpoint, isExtraSmallBreakpoint, isIconA11yDisabled, isIconAllyEnabled, isLargeBreakpoint, isManifestMediaDataSizes, isManifestRegistryItem, isMarginSpacing, isMediaManifest, isMediaManifestRecord, isMediaManifestRecordWithPath, isMediaManifestRecordWithSizes, isMediumBreakpoint, isMinifiedMediaManifest, isNavigationUser, isOrdinalSlider, isPaddingSpacing, isPanelInitiatorElement, isPanelInitiatorString, isPartialManifestMediaDataSizes, isPreciseContinuousSlider, isRangeInput, isSectionNavGroup, isSectionNavItem, isSmallBreakpoint, isStaticRegistryItem, isSvgElement, isTextInputDataValid, logWarning, mapIconSizeToSuffix, normalizeIconSize, notSupportedByDirectiveMsg, notSupportedByKindMsg, spacingTokens, throwError, validateManifestData };
